import React from 'react';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import './style.scss';
import { termsAr } from './terms-ar';
import { termsCo } from './terms-co';
import { termsCl } from './terms-cl';
import { termsMa } from './terms-ma';
import language from '@language';

ReactModal.setAppElement('body');

export default class Form extends React.Component<any, any> {
  constructor(props) {
    super(props);
    const { initValues } = this.props;
    this.state = {
      fields: initValues,
    };
  }

  handleChange(event) {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;
    const { fields } = this.props;

    let newFields = {
      ...fields,
      [fieldName]: fieldValue,
    };

    if (['conditions'].indexOf(fieldName) !== -1) {
      newFields = {
        ...newFields,
        conditions: !fields.conditions,
      };
    }

    this.props.onChange(newFields);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(this.props.fields);
  }

  showTerms(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  getTerms() {
    const { country } = this.props;
    switch (country) {
      case 'AR':
        return { __html: termsAr };
      case 'CO':
        return { __html: termsCo };
      case 'CL':
        return { __html: termsCl };
      case 'MA':
        return { __html: termsMa };
    }
  }

  render() {
    const { showModal } = this.state;
    const {
      errors,
      sending,
      showValidations,
      errorMessage,
      banks,
      dlocalBanks,
      fields,
      country,
      currency,
      hideDocument,
    } = this.props;

    return (
      <div className="bank-transfer">
        {sending && (
          <div className="overlay">
            <div className="loader" />
          </div>
        )}
        {errorMessage && (
          <div id="error-box" className="error-box">
            <p>{errorMessage}</p>
          </div>
        )}
        <div className="warning-box margin-bottom margin-top">
          <p>
            <i className="icon fa fa-exclamation-triangle" />
            {language.important}
          </p>
          <p>{language.payment_disclaimer_1}</p>
          {country === 'MA' ? (
            <p>
              <b>{language.step} 1 : </b> {language.payment_disclaimer_2}
            </p>
          ) : (
            <p>
              <b>{language.step} 1:</b> {language.payment_disclaimer_2}
            </p>
          )}
          {country === 'MA' ? (
            <p>
              <b>{language.step} 2 : </b> {language.payment_disclaimer_3}
            </p>
          ) : (
            <p>
              <b>{language.step} 2:</b> {language.payment_disclaimer_3}
            </p>
          )}
          {country === 'MA' && (
            <p>
              <b>{language.step} 3 : </b> {language.payment_disclaimer_4}
            </p>
          )}
        </div>
        <form
          id="dd-form"
          onSubmit={(e) => this.handleSubmit(e)}
          className={`${showValidations ? 'sended' : ''}`}
        >
          <div className="row-input">
            {/*client_number*/}
            <div
              className={`input ${errors['client_number'] ? 'invalid' : ''}`}
            >
              <label>{language.client_number}</label>
              <input
                name="client_number"
                type="text"
                value={fields.client_number}
                onChange={(e) => this.handleChange(e)}
                maxLength={8}
              />
              {errors['client_number'] && (
                <div className="error-tooltip">{errors['client_number']}</div>
              )}
            </div>

            {/*property_number*/}
            <div
              className={`input ${errors['property_name'] ? 'invalid' : ''}`}
            >
              <label>{language.property_name}</label>
              <input
                name="property_name"
                value={fields.property_name}
                type="text"
                onChange={(e) => this.handleChange(e)}
              />
              {errors['property_name'] && (
                <div className="error-tooltip">{errors['property_name']}</div>
              )}
            </div>
          </div>

          <div className="row-input">
            {/*holder_name*/}
            <div className={`input ${errors['holder_name'] ? 'invalid' : ''}`}>
              <label>{language.holder_name}</label>
              <input
                value={fields.holder_name}
                name="holder_name"
                type="text"
                onChange={(e) => this.handleChange(e)}
              />
              {errors['holder_name'] && (
                <div className="error-tooltip">{errors['holder_name']}</div>
              )}
            </div>

            {/*cuil*/}
            {!hideDocument && (
              <div className={`input ${errors['document'] ? 'invalid' : ''}`}>
                <label>{language.document}</label>
                <input
                  value={fields.document}
                  name="document"
                  type="text"
                  onChange={(e) => this.handleChange(e)}
                />
                {errors['document'] && (
                  <div className="error-tooltip">{errors['document']}</div>
                )}
              </div>
            )}
          </div>

          <div className="row-input">
            {/*email*/}
            <div className={`input ${errors['email'] ? 'invalid' : ''}`}>
              <label>{language.email}</label>
              <input
                value={fields['email']}
                name="email"
                type="text"
                onChange={(e) => this.handleChange(e)}
              />
            </div>
          </div>

          <div className="row-input">
            {/*invoice_number*/}
            <div
              className={`input ${errors['invoice_number'] ? 'invalid' : ''}`}
            >
              <ReactTooltip
                id="invoice_number"
                place="top"
                type="dark"
                effect="solid"
              >
                <span>{language.invoice_disclaimer}</span>
              </ReactTooltip>
              <label>
                <span>
                  {language.invoice_number}{' '}
                  <a className="info" data-tip data-for="invoice_number" />
                </span>
              </label>
              <input
                value={fields['invoice_number']}
                name="invoice_number"
                type="text"
                onChange={(e) => this.handleChange(e)}
                maxLength={109}
              />

              {errors['invoice_number'] && (
                <div className="error-tooltip">{errors['invoice_number']}</div>
              )}
            </div>

            {/*amount*/}
            <div className={`input ${errors['amount'] ? 'invalid' : ''}`}>
              <label>{language.amount}</label>

              <div className="group">
                {currency && <span className="symbol">{currency}</span>}
                <input
                  value={fields['amount']}
                  className="small"
                  name="amount"
                  type="text"
                  maxLength={15}
                  onChange={(e) => this.handleChange(e)}
                />
              </div>
              {errors['amount'] && (
                <div className="error-tooltip">{errors['amount']}</div>
              )}
            </div>
          </div>

          <div className="row-input">
            <div className={`input ${errors['bank_origin'] ? 'invalid' : ''}`}>
              <label>
                <span>{language.bank_origin}</span>
              </label>
              <select
                value={fields['bank_origin']}
                name="bank_origin"
                onChange={(e) => this.handleChange(e)}
              >
                <option value="" />
                {banks.map((bank, key) => (
                  <option key={key} value={bank.id}>
                    {bank.name}
                  </option>
                ))}
              </select>
              {errors['invoice_number'] && (
                <div className="error-tooltip">{errors['bank_origin']}</div>
              )}
            </div>
          </div>

          <div className="row-input">
            <div className="conditions">
              <label>
                <input
                  type="checkbox"
                  onChange={(e) => this.handleChange(e)}
                  name="conditions"
                />{' '}
                {language.terms_1}{' '}
                <a onClick={(e) => this.showTerms(e)} href="#">
                  {language.terms_2}
                </a>
              </label>
              <ReactModal
                isOpen={showModal}
                contentLabel="Minimal Modal Example"
                className="terms_modal"
              >
                <div dangerouslySetInnerHTML={this.getTerms()} />
                <button onClick={this.handleCloseModal}>
                  {language.close}
                </button>
              </ReactModal>
            </div>
          </div>

          <div className="submit">
            <button type="submit">{language.send}</button>
          </div>
        </form>
      </div>
    );
  }
}
